import { render, staticRenderFns } from "./PayScanCode.vue?vue&type=template&id=cd10e1b4&scoped=true"
import script from "./PayScanCode.vue?vue&type=script&lang=js"
export * from "./PayScanCode.vue?vue&type=script&lang=js"
import style0 from "./PayScanCode.vue?vue&type=style&index=0&id=cd10e1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd10e1b4",
  null
  
)

export default component.exports